<template>
<div>
  <v-layout row justify-center>
    <v-dialog v-model="val" :max-width="maxWidth" scrollable>
      <v-card>
        <v-toolbar color="primary" class="white--text">
                  {{title}}
          <v-spacer></v-spacer>
          <v-icon @click.stop="val=false" color="white">close</v-icon>
        </v-toolbar>
        <!-- <v-system-bar window color="primary" dark>
          {{title}}
          <v-spacer></v-spacer>

          <v-icon @click.stop="val=false">close</v-icon>
        </v-system-bar> -->
        <slot name="header"></slot>

        <v-card-text :style="fstyle()">
          <slot/>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>

          <slot name="btn"></slot>
          <v-btn color=red flat @click.stop="val=false">{{this.$t('Cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</div>
</template>

<script>
export default {
  components: {},

  props: ['value', 'title', 'maxWidth', 'cardtextstyle'],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },

    fmaxWidth: {
      get: function () {
          if (this.maxWidth == undefined) {
            this.ffmaxWidth == 10
          } else {
            this.ffmaxWidth = this.maxWidth;
          }
        return this.ffmaxWidth;
      },
      set: function (newValue) {
        this.ffmaxWidth = newValue;
      },
    }

  },

  data() {
    return {

      ilkmaxWidth: null,
      ffmaxWidth: 300,

    }
  },
  methods: {
    fstyle() {
      if (this.cardtextstyle != undefined) {
        return this.cardtextstyle
      } else
        return "height: 650px;"
    },


  }
}
</script>
